import { TagERP, TagType } from "@finanedi.es/storybook"
import {
  faCircleCheck,
  faCircleXmark,
  faClock,
  faPencil,
  faTrashCan,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  ESTADO_REVISION_DOCUMENTO_COMERCIAL,
  EstadoRevisionDocumentoComercialType,
} from "api/Types/EstadoRevisionDocumentoComercial"
import { t } from "i18next"

export const EstadoRevisionActual = (
  estadoRevisionActual: EstadoRevisionDocumentoComercialType,
  id?: string
) => {
  const ESTADO_REVISION_PROPERTIES: Record<
    EstadoRevisionDocumentoComercialType,
    {
      icon: React.ReactNode
      color: TagType
      text: string
    }
  > = {
    [ESTADO_REVISION_DOCUMENTO_COMERCIAL.PENDIENTE]: {
      icon: <FontAwesomeIcon icon={faClock} />,
      color: "alternativeOne",
      text: t("filters.estadoRevision.pendingLabel"),
    },
    [ESTADO_REVISION_DOCUMENTO_COMERCIAL.VALIDADO]: {
      icon: <FontAwesomeIcon icon={faCircleCheck} />,
      color: "success",
      text: t("filters.estadoRevision.validateLabel"),
    },
    [ESTADO_REVISION_DOCUMENTO_COMERCIAL.RECHAZADO]: {
      icon: <FontAwesomeIcon icon={faCircleXmark} />,
      color: "danger",
      text: t("filters.estadoRevision.rejectedLabel"),
    },
    [ESTADO_REVISION_DOCUMENTO_COMERCIAL.ELIMINADO]: {
      icon: <FontAwesomeIcon icon={faTrashCan} />,
      color: "neutral",
      text: t("filters.estadoRevision.deleteLabel"),
    },
    [ESTADO_REVISION_DOCUMENTO_COMERCIAL.BORRADOR]: {
      icon: <FontAwesomeIcon icon={faPencil} />,
      color: "info",
      text: t("filters.estadoRevision.draftLabel"),
    },
  }
  const { icon, color, text } =
    (estadoRevisionActual &&
      ESTADO_REVISION_PROPERTIES[estadoRevisionActual]) ||
    {}

  return (
    <div className='tw-flex tw-justify-center tw-items-center !tw-w-full'>
      <TagERP
        id={id}
        value={text}
        color={color}
        icon={icon}
      />
    </div>
  )
}
